import app from 'flarum/forum/app';
import Component from 'flarum/common/Component';
export default class ForumTrashPanel extends Component {
  oninit(vnode) {
    super.oninit(vnode);
    this.onChanged = typeof vnode.attrs.onChanged === 'function' ? vnode.attrs.onChanged : null;
    this.mode = 'remove';
    this.removalItems = [];
    this.removedItems = [];
    this.activeById = new Map();
    this.removedById = new Map();
    this.canTrash = false;
    this.canPurge = false;
    this.loading = false;
    this.actionLoading = false;
    this.error = '';
    this.message = '';
    this.messageType = 'success';
    this.removeSearch = '';
    this.removeSelectedIds = new Set();
    this.removePreview = null;
    this.trashSearch = '';
    this.trashSelectedIds = new Set();
    this.trashPreview = null;
    this.purgeConfirmation = '';
    this.loadData();
  }
  api(path) {
    return String(app.forum.attribute('apiUrl') || '/api').replace(/\/$/, '') + path;
  }
  normalize(value) {
    return String(value || '').normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLocaleLowerCase('fr').trim();
  }
  formatDate(value) {
    if (!value) return '—';
    try {
      return new Intl.DateTimeFormat('fr-FR', {
        dateStyle: 'short',
        timeStyle: 'short'
      }).format(new Date(String(value).replace(' ', 'T') + 'Z'));
    } catch (e) {
      return String(value);
    }
  }
  errorText(error, fallback) {
    return error?.response?.errors?.[0]?.detail || error?.response?.error || fallback;
  }
  async loadData() {
    if (this.loading) return;
    this.loading = true;
    this.error = '';
    try {
      const data = await app.request({
        method: 'GET',
        url: this.api('/val/moderation/forums?_=' + Date.now())
      });
      this.canTrash = !!data.can_trash;
      this.canPurge = !!data.can_purge;
      this.removalItems = data.removal_items || [];
      this.removedItems = data.removed_items || [];
      this.activeById = new Map(this.removalItems.map(item => [Number(item.id), item]));
      this.removedById = new Map(this.removedItems.map(item => [Number(item.id), item]));
      const activeIds = new Set(this.removalItems.map(item => String(item.id)));
      const removedIds = new Set(this.removedItems.map(item => String(item.id)));
      this.removeSelectedIds = new Set(Array.from(this.removeSelectedIds).filter(id => activeIds.has(String(id))));
      this.trashSelectedIds = new Set(Array.from(this.trashSelectedIds).filter(id => removedIds.has(String(id))));
      if (!this.removeSelectedIds.size) this.removePreview = null;
      if (!this.trashSelectedIds.size) {
        this.trashPreview = null;
        this.purgeConfirmation = '';
      }
    } catch (e) {
      this.error = 'Impossible de charger la corbeille des forums.';
      this.removalItems = [];
      this.removedItems = [];
    } finally {
      this.loading = false;
      m.redraw();
    }
  }
  activeLabel(item) {
    const names = [item.name];
    let current = item;
    let guard = 0;
    while (current?.parent_id !== null && guard < 20) {
      current = this.activeById.get(Number(current.parent_id)) || null;
      if (!current) break;
      names.unshift(current.name);
      guard += 1;
    }
    return `${names.join(' → ')} (#${item.id})`;
  }
  trashLabel(item) {
    const names = [item.name];
    let parentId = item.previous_parent_id ?? null;
    let guard = 0;
    while (parentId !== null && guard < 20) {
      const parent = this.removedById.get(Number(parentId)) || this.activeById.get(Number(parentId)) || null;
      if (!parent) break;
      names.unshift(parent.name);
      parentId = parent.previous_parent_id ?? parent.parent_id ?? null;
      guard += 1;
    }
    return `${names.join(' → ')} (#${item.id})`;
  }
  visibleRemovalItems() {
    const q = this.normalize(this.removeSearch);
    if (!q) return [];
    return this.removalItems.filter(item => this.normalize(`${this.activeLabel(item)} ${item.slug || ''}`).includes(q));
  }
  visibleTrashItems() {
    const q = this.normalize(this.trashSearch);
    if (!q) return this.removedItems;
    return this.removedItems.filter(item => this.normalize(`${this.trashLabel(item)} ${item.slug || ''} ${item.removed_by_username || ''}`).includes(q));
  }
  selectedRemovalItems() {
    return this.removalItems.filter(item => this.removeSelectedIds.has(String(item.id)));
  }
  selectedTrashItems() {
    return this.removedItems.filter(item => this.trashSelectedIds.has(String(item.id)));
  }
  toggleRemoval(item) {
    const id = String(item.id);
    if (this.removeSelectedIds.has(id)) {
      this.removeSelectedIds.delete(id);
    } else {
      this.removeSelectedIds.add(id);
    }
    this.removePreview = null;
    this.message = '';
  }
  toggleTrash(item) {
    const id = String(item.id);
    if (this.trashSelectedIds.has(id)) {
      this.trashSelectedIds.delete(id);
    } else {
      this.trashSelectedIds.add(id);
    }
    this.trashPreview = null;
    this.purgeConfirmation = '';
    this.message = '';
  }
  selectRemovalResults(items) {
    items.forEach(item => this.removeSelectedIds.add(String(item.id)));
    this.removePreview = null;
  }
  selectTrashResults(items) {
    items.forEach(item => this.trashSelectedIds.add(String(item.id)));
    this.trashPreview = null;
    this.purgeConfirmation = '';
  }
  clearRemovalSelection() {
    this.removeSelectedIds.clear();
    this.removePreview = null;
  }
  clearTrashSelection() {
    this.trashSelectedIds.clear();
    this.trashPreview = null;
    this.purgeConfirmation = '';
  }
  async preview(ids) {
    const qs = new URLSearchParams({
      tag_ids: ids.join(',')
    });
    return app.request({
      method: 'GET',
      url: this.api('/val/moderation/forums/trash/preview?' + qs.toString())
    });
  }
  async previewRemovalSelection() {
    const ids = Array.from(this.removeSelectedIds);
    if (!ids.length || this.actionLoading) return;
    this.actionLoading = true;
    this.removePreview = null;
    this.message = '';
    try {
      this.removePreview = await this.preview(ids);
    } catch (e) {
      this.messageType = 'error';
      this.message = this.errorText(e, 'Impossible de prévisualiser le retrait.');
    } finally {
      this.actionLoading = false;
      m.redraw();
    }
  }
  async previewTrashSelection() {
    const ids = Array.from(this.trashSelectedIds);
    if (!ids.length || this.actionLoading) return;
    this.actionLoading = true;
    this.trashPreview = null;
    this.purgeConfirmation = '';
    this.message = '';
    try {
      this.trashPreview = await this.preview(ids);
    } catch (e) {
      this.messageType = 'error';
      this.message = this.errorText(e, 'Impossible de prévisualiser la sélection.');
    } finally {
      this.actionLoading = false;
      m.redraw();
    }
  }
  async notifyChanged() {
    await this.loadData();
    if (this.onChanged) {
      await this.onChanged();
    }
    m.redraw();
  }
  selectionNames(preview) {
    return (preview?.tags || []).map(tag => `• ${tag.name} (#${tag.id})`).join('\n');
  }
  async removeForums() {
    const preview = this.removePreview;
    if (!preview || this.actionLoading) return;
    const blockers = preview.active_children_outside || [];
    if (blockers.length) {
      this.messageType = 'error';
      this.message = 'La sélection possède encore des sous-forums actifs non sélectionnés.';
      return;
    }
    const count = (preview.tags || []).length;
    const hidden = Number(preview.will_disappear_discussions || 0);
    const shared = Number(preview.will_remain_visible_discussions || 0);
    if (!confirm(`Retirer ${count} forum(s) de l’affichage ?\n\n` + `${this.selectionNames(preview)}\n\n` + `${hidden.toLocaleString('fr-FR')} discussion(s) ne seront plus affichées.\n` + `${shared.toLocaleString('fr-FR')} discussion(s) resteront visibles dans d’autres forums.\n\n` + 'Aucune donnée ne sera supprimée de la base.')) {
      return;
    }
    this.actionLoading = true;
    this.message = '';
    try {
      const data = await app.request({
        method: 'POST',
        url: this.api('/val/moderation/forums/trash/remove'),
        body: {
          tag_ids: Array.from(this.removeSelectedIds).map(Number)
        }
      });
      this.messageType = 'success';
      this.message = `${Number(data.changed || count)} forum(s) placé(s) dans la corbeille.`;
      this.clearRemovalSelection();
      this.mode = 'trash';
      await this.notifyChanged();
    } catch (e) {
      this.messageType = 'error';
      this.message = this.errorText(e, 'Le retrait des forums a échoué.');
    } finally {
      this.actionLoading = false;
      m.redraw();
    }
  }
  async restoreForums() {
    const preview = this.trashPreview;
    if (!preview || this.actionLoading) return;
    const blockers = preview.restore_parent_blockers || [];
    if (blockers.length) {
      this.messageType = 'error';
      this.message = 'Ajoute les forums parents encore retirés à la sélection avant de restaurer.';
      return;
    }
    const count = (preview.tags || []).length;
    if (!confirm(`Restaurer ${count} forum(s) et les remettre dans l’affichage ?\n\n` + this.selectionNames(preview))) {
      return;
    }
    this.actionLoading = true;
    this.message = '';
    try {
      const data = await app.request({
        method: 'POST',
        url: this.api('/val/moderation/forums/trash/restore'),
        body: {
          tag_ids: Array.from(this.trashSelectedIds).map(Number)
        }
      });
      this.messageType = 'success';
      this.message = `${Number(data.changed || count)} forum(s) restauré(s).`;
      this.clearTrashSelection();
      await this.notifyChanged();
    } catch (e) {
      this.messageType = 'error';
      this.message = this.errorText(e, 'La restauration des forums a échoué.');
    } finally {
      this.actionLoading = false;
      m.redraw();
    }
  }
  purgeExpected(preview) {
    const count = (preview?.tags || []).length;
    if (count === 1) {
      return `PURGER ${preview.tags[0].id}`;
    }
    return `PURGER ${count} FORUMS`;
  }
  async purgeForums() {
    const preview = this.trashPreview;
    if (!preview || !this.canPurge || this.actionLoading) return;
    const blockers = preview.all_children_outside || [];
    if (blockers.length) {
      this.messageType = 'error';
      this.message = 'La sélection possède encore des sous-forums non sélectionnés.';
      return;
    }
    const expected = this.purgeExpected(preview);
    if (this.purgeConfirmation !== expected) return;
    const count = (preview.tags || []).length;
    if (!confirm(`DERNIÈRE CONFIRMATION\n\n` + `Purger définitivement ${count} forum(s) ?\n\n` + `${this.selectionNames(preview)}\n\n` + `${Number(preview.exclusive_discussions || 0).toLocaleString('fr-FR')} discussion(s) et ` + `${Number(preview.exclusive_posts || 0).toLocaleString('fr-FR')} message(s) seront supprimés de la base.\n` + `${Number(preview.shared_discussions || 0).toLocaleString('fr-FR')} discussion(s) partagée(s) seront conservées.\n\n` + 'Cette opération est irréversible.')) {
      return;
    }
    this.actionLoading = true;
    this.message = '';
    try {
      const data = await app.request({
        method: 'POST',
        url: this.api('/val/moderation/forums/trash/purge'),
        body: {
          tag_ids: Array.from(this.trashSelectedIds).map(Number),
          confirm: expected
        }
      });
      this.messageType = 'success';
      this.message = `${Number(data.purged_tags || count)} forum(s) purgé(s) définitivement : ` + `${Number(data.deleted_discussions || 0).toLocaleString('fr-FR')} discussion(s) supprimée(s).`;
      this.clearTrashSelection();
      await this.notifyChanged();
    } catch (e) {
      this.messageType = 'error';
      this.message = this.errorText(e, 'La purge définitive a échoué.');
    } finally {
      this.actionLoading = false;
      m.redraw();
    }
  }
  selectedSummary(items, labelFn, clearFn) {
    if (!items.length) return null;
    return m('.ValModerationForumTrash-selection', [m('.ValModerationForumTrash-selectionHeader', [m('strong', `${items.length} forum${items.length > 1 ? 's' : ''} sélectionné${items.length > 1 ? 's' : ''}`), m('button.Button.Button--text', {
      type: 'button',
      disabled: this.actionLoading,
      onclick: clearFn
    }, 'Tout désélectionner')]), m('.ValModerationForumTrash-selectionList', items.map(item => m('span', {
      key: item.id
    }, labelFn(item))))]);
  }
  previewStats(preview, mode) {
    if (!preview) return null;
    const count = (preview.tags || []).length;
    if (mode === 'remove') {
      const blockers = preview.active_children_outside || [];
      return m('.ValModerationForumTrash-preview', [m('h4', `Prévisualisation — ${count} forum${count > 1 ? 's' : ''}`), m('dl.ValModerationForumTrash-stats', [m('dt', 'Discussions liées à la sélection'), m('dd', Number(preview.attached_discussions || 0).toLocaleString('fr-FR')), m('dt', 'Disparaîtront de l’affichage'), m('dd', Number(preview.will_disappear_discussions || 0).toLocaleString('fr-FR')), m('dt', 'Resteront visibles ailleurs'), m('dd', Number(preview.will_remain_visible_discussions || 0).toLocaleString('fr-FR'))]), blockers.length ? m('.Alert.Alert--error', ['Retrait groupé impossible : ces sous-forums actifs ne sont pas sélectionnés : ', blockers.map((child, index) => [index ? ', ' : '', `${child.name} (#${child.id})`]), '. Ajoute-les à la sélection.']) : m('p.helpText', 'Les enfants sélectionnés sont retirés avant leurs parents. Le retrait reste entièrement réversible.'), m('button.Button.Button--danger', {
        type: 'button',
        disabled: this.actionLoading || blockers.length > 0,
        onclick: () => this.removeForums()
      }, this.actionLoading ? 'Retrait…' : `Retirer ${count} forum${count > 1 ? 's' : ''} de l’affichage`)]);
    }
    const purgeBlockers = preview.all_children_outside || [];
    const restoreBlockers = preview.restore_parent_blockers || [];
    const expected = this.purgeExpected(preview);
    return m('.ValModerationForumTrash-preview', [m('h4', `Prévisualisation — ${count} forum${count > 1 ? 's' : ''}`), m('dl.ValModerationForumTrash-stats', [m('dt', 'Discussions liées à la sélection'), m('dd', Number(preview.attached_discussions || 0).toLocaleString('fr-FR')), m('dt', 'Discussions supprimées si purge'), m('dd', Number(preview.exclusive_discussions || 0).toLocaleString('fr-FR')), m('dt', 'Messages supprimés si purge'), m('dd', Number(preview.exclusive_posts || 0).toLocaleString('fr-FR')), m('dt', 'Discussions partagées conservées'), m('dd', Number(preview.shared_discussions || 0).toLocaleString('fr-FR'))]), restoreBlockers.length ? m('.Alert.Alert--error', ['Restauration groupée bloquée : ', restoreBlockers.map((blocker, index) => [index ? ', ' : '', blocker.parent_name ? `${blocker.parent_name} (#${blocker.parent_id}) est encore dans la corbeille` : `parent #${blocker.parent_id} introuvable`]), '. Ajoute le parent à la sélection si nécessaire.']) : null, purgeBlockers.length ? m('.Alert.Alert--error', ['Purge groupée bloquée : ces sous-forums ne sont pas sélectionnés : ', purgeBlockers.map((child, index) => [index ? ', ' : '', `${child.name} (#${child.id})`]), '. Ajoute-les à la sélection.']) : null, m('.ValModerationForumTrash-actions', [m('button.Button.Button--primary', {
      type: 'button',
      disabled: this.actionLoading || restoreBlockers.length > 0,
      onclick: () => this.restoreForums()
    }, this.actionLoading ? 'Traitement…' : `Restaurer ${count} forum${count > 1 ? 's' : ''}`)]), this.canPurge ? m('.ValModerationForumTrash-purge', [m('h5', 'Purge définitive — administrateurs uniquement'), m('p.helpText', 'Pour une sélection parent + enfants, les enfants sont purgés en premier. Les discussions qui n’ont aucun autre tag hors de la sélection sont supprimées ; les discussions partagées restent en place.'), m('label.ValModerationField', [m('span', `Tape « ${expected} » pour déverrouiller`), m('input.FormControl', {
      type: 'text',
      value: this.purgeConfirmation,
      disabled: this.actionLoading || purgeBlockers.length > 0,
      autocomplete: 'off',
      oninput: e => {
        this.purgeConfirmation = e.target.value;
      }
    })]), m('button.Button.Button--danger', {
      type: 'button',
      disabled: this.actionLoading || purgeBlockers.length > 0 || this.purgeConfirmation !== expected,
      onclick: () => this.purgeForums()
    }, this.actionLoading ? 'Purge…' : `Purger définitivement ${count} forum${count > 1 ? 's' : ''}`)]) : null]);
  }
  removeView() {
    const selected = this.selectedRemovalItems();
    const visible = this.visibleRemovalItems();
    const q = this.normalize(this.removeSearch);
    return m('.ValModerationForumTrash-pane', [m('h4', 'Retirer des forums de l’affichage'), m('p.helpText', 'Tu peux sélectionner plusieurs sous-forums et leur parent en une seule fois. Les enfants sont retirés avant le parent. Une prévisualisation globale est obligatoire.'), m('input.FormControl.ValModerationForumTrash-search', {
      type: 'search',
      value: this.removeSearch,
      placeholder: 'Rechercher un forum…',
      disabled: this.actionLoading,
      oninput: e => {
        this.removeSearch = e.target.value;
        this.removePreview = null;
      }
    }), q && visible.length ? m('.ValModerationForumTrash-listToolbar', [m('span', `${visible.length} résultat${visible.length > 1 ? 's' : ''}`), m('button.Button.Button--text', {
      type: 'button',
      disabled: this.actionLoading,
      onclick: () => this.selectRemovalResults(visible)
    }, 'Sélectionner les résultats')]) : null, q ? m('.ValModerationForumTrash-results', visible.length ? visible.map(item => m('label.ValModerationForumTrash-result.ValModerationForumTrash-choice', {
      key: item.id
    }, [m('input', {
      type: 'checkbox',
      checked: this.removeSelectedIds.has(String(item.id)),
      disabled: this.actionLoading,
      onchange: () => this.toggleRemoval(item)
    }), m('span', this.activeLabel(item))])) : m('p.ValModerationForumTrash-empty', 'Aucun forum correspondant.')) : m('p.ValModerationForumTrash-hint', 'Saisis quelques lettres : les résultats apparaîtront immédiatement.'), this.selectedSummary(selected, item => this.activeLabel(item), () => this.clearRemovalSelection()), selected.length ? m('.ValModerationForumTrash-selectionActions', [m('button.Button.Button--primary', {
      type: 'button',
      disabled: this.actionLoading,
      onclick: () => this.previewRemovalSelection()
    }, this.actionLoading ? 'Prévisualisation…' : 'Prévisualiser la sélection')]) : null, this.removePreview ? this.previewStats(this.removePreview, 'remove') : null]);
  }
  trashView() {
    const visible = this.visibleTrashItems();
    const selected = this.selectedTrashItems();
    const q = this.normalize(this.trashSearch);
    return m('.ValModerationForumTrash-pane', [m('h4', `Corbeille (${this.removedItems.length})`), this.removedItems.length ? [m('input.FormControl.ValModerationForumTrash-search', {
      type: 'search',
      value: this.trashSearch,
      placeholder: 'Filtrer la corbeille…',
      disabled: this.actionLoading,
      oninput: e => {
        this.trashSearch = e.target.value;
        this.trashPreview = null;
        this.purgeConfirmation = '';
      }
    }), q && visible.length ? m('.ValModerationForumTrash-listToolbar', [m('span', `${visible.length} résultat${visible.length > 1 ? 's' : ''}`), m('button.Button.Button--text', {
      type: 'button',
      disabled: this.actionLoading,
      onclick: () => this.selectTrashResults(visible)
    }, 'Sélectionner les résultats filtrés')]) : null, m('.ValModerationForumTrash-removedList', visible.length ? visible.map(item => m('label.ValModerationForumTrash-removed.ValModerationForumTrash-choice', {
      key: item.id,
      className: this.trashSelectedIds.has(String(item.id)) ? 'is-selected' : ''
    }, [m('input', {
      type: 'checkbox',
      checked: this.trashSelectedIds.has(String(item.id)),
      disabled: this.actionLoading,
      onchange: () => this.toggleTrash(item)
    }), m('span.ValModerationForumTrash-choiceText', [m('strong', this.trashLabel(item)), m('span', `Retiré le ${this.formatDate(item.removed_at)}` + (item.removed_by_username ? ` par ${item.removed_by_username}` : item.removed_by ? ` par #${item.removed_by}` : ''))])])) : m('p.ValModerationForumTrash-empty', 'Aucun forum correspondant.'))] : m('p.ValModerationForumTrash-empty', 'La corbeille est vide.'), this.selectedSummary(selected, item => this.trashLabel(item), () => this.clearTrashSelection()), selected.length ? m('.ValModerationForumTrash-selectionActions', [m('button.Button.Button--primary', {
      type: 'button',
      disabled: this.actionLoading,
      onclick: () => this.previewTrashSelection()
    }, this.actionLoading ? 'Prévisualisation…' : 'Prévisualiser la sélection')]) : null, this.trashPreview ? this.previewStats(this.trashPreview, 'trash') : null]);
  }
  view() {
    if (this.loading) {
      return m('.ValModerationForumTrash.ValModerationForums-loading', 'Chargement de la corbeille…');
    }
    if (!this.canTrash) return null;
    return m('.ValModerationForumTrash', [m('.ValModerationForumTrash-header', [m('div', [m('h3', 'Corbeille des forums'), m('p.helpText', 'Les modérateurs peuvent retirer et restaurer, y compris par sélection multiple. La suppression physique de la base est réservée aux administrateurs.')]), m('.ValModerationForumTrash-tabs', [m('button.Button', {
      type: 'button',
      className: this.mode === 'remove' ? 'Button--primary' : '',
      onclick: () => {
        this.mode = 'remove';
        this.message = '';
      }
    }, 'Retirer'), m('button.Button', {
      type: 'button',
      className: this.mode === 'trash' ? 'Button--primary' : '',
      onclick: () => {
        this.mode = 'trash';
        this.message = '';
      }
    }, `Corbeille (${this.removedItems.length})`)])]), this.error ? m('.Alert.Alert--error', this.error) : null, this.message ? m(`.Alert.Alert--${this.messageType}.ValModerationForumTrash-message`, this.message) : null, this.mode === 'trash' ? this.trashView() : this.removeView()]);
  }
}